import React from "react"
import loader from "../../assets/images/loader.gif"

export default function Loading() {
	return <img className="loading-icon" src={loader} alt="" />
}
